import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var Camera = createReactComponent("Camera", ["svg", defaultAttributes, [["path", {
  d: "M14.5 4h-5L7 7H4a2 2 0 00-2 2v9a2 2 0 002 2h16a2 2 0 002-2V9a2 2 0 00-2-2h-3l-2.5-3z",
  key: "13xylk"
}], ["circle", {
  cx: "12",
  cy: "13",
  r: "3",
  key: "5yg47v"
}]]]);
export default Camera;